<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="사업장명(필수)"
      :options="[
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태(필수)', value: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 장비정보 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="장비정보"
      :tableData="[
        { id: 'name', title: '장비명', type: 'text' },
        { id: 'manufacturer', title: '제조사 또는 모델명', type: 'text' },
        { id: 'standard', title: '장비 규격(정격하중 또는 인양하중 등)', type: 'text' },
      ]"
      :mobile="['name', 'manufacturer']"
      v-model="form.equipmentList"
      class="mt-28px"
    />

    <!-- 점검 대상 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="장비정보"
      :tableData="[
        { id: 'target', title: '장비명', type: 'text' },
        { id: 'director', title: '담당자', type: 'text' },
        { id: 'phone', title: '연락처', type: 'text' },
        { id: 'note', title: '비고', type: 'text' },
      ]"
      :mobile="['target', 'director']"
      v-model="form.targetInspectionList"
      class="mt-28px"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" title="작업장 합동점검" v-model="form.inspectList" class="mt-28px" />

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검일: { required },
        재해형태: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          작업장합동점검_사업장명: [],
          작업장합동점검_점검대상: [],
        };

        value.summary["작업장합동점검_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.targetInspectionList) {
          value.summary["작업장합동점검_점검대상"].push({
            [data.target]: 1,
          });
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",

        inputD_1: {},
        inputD_2: "",
        inputD_3: {},
        inputD_4: "",
        inputD_5: {},
        inputD_6: "",
        inputD_7: {},
        inputD_8: "",

        photoList: [],
        fileList: [],
        equipmentList: [{}],
        targetInspectionList: [{}],
        inspectList: [
          {
            content: "안전관리자 지정 여부",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "보건관리자 지정 여부",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "안전보건교육 실시 여부",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "교육결과 기록보존상태",
            isChecked: "",
            title: "안전·보건 관리조직 및 교육",
          },
          {
            content: "안전관리비 적정계상 여부",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "안전관리비 집행실태(타목적, 용도외 사용 등)",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "항목별 적정비율 집행 여부",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "보호구 적격품(검정) 구입 여부",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "개인보호구 지급 여부",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "개인보호구 착용 여부 (방진마스크, 귀마개, 안전모, 안전대, 안전화 등)",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "유해･위험방지계획서 제출 및 이행 여부 등",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "위험물(인화성 물질 등) 관리 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "화재예방 대책(소화기 비치 비상 연락망 편성 등)",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "위험,주의,경고 등 표지판 설치 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "작업장 내 자재의 정리 정돈 및 안전통로 확보 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["재해형태"].required) return "재해형태를 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
